import Translator from '../Translator';

import tirolLogo from '../../assets/customers/Tirol.png';
import vapzaLogo from '../../assets/customers/Vapza.png';
import sigLogo from '../../assets/customers/Sig.png';
import dafLogo from '../../assets/customers/Daf.png';
import elisLogo from '../../assets/customers/Elis.png';
import rofaLogo from '../../assets/customers/Rofa.png';
import fevLogo from '../../assets/customers/Fev.png';
import aguiaLogo from '../../assets/customers/Águia Sistemas.svg';
import morathLogo from '../../assets/customers/Morath.png';
import searaLogo from '../../assets/customers/Seara.png';
import uniumLogo from '../../assets/customers/Unium.png';
import castrolandaLogo from '../../assets/customers/Castrolanda.png';

import { Title, TitleBorderBottom, TitleBorderBottomContainer, Content, Logo } from './style';

export default function Customers() {
  return (
    <>
      <Title id="customers">
        <h2>
          <Translator path={'customers.title'} />
        </h2>
      </Title>

      <TitleBorderBottomContainer>
        <TitleBorderBottom />
      </TitleBorderBottomContainer>

      <Content>
        <Logo src={tirolLogo} height={80} />
        <Logo src={vapzaLogo} height={100} />
        <Logo src={sigLogo} height={50} />
        <Logo src={dafLogo} height={50} />
        <Logo src={elisLogo} height={50} />
        <Logo src={rofaLogo} height={70} />
        <Logo src={fevLogo} height={50} />
        <Logo src={aguiaLogo} height={60} />
        <Logo src={morathLogo} height={100} />
        <Logo src={searaLogo} height={70} />
        <Logo src={uniumLogo} height={100} />
        <Logo src={castrolandaLogo} height={90} />
      </Content>
    </>
  );
}
